import { useContext } from 'react';
import { TenantContext } from './tenant-context-definition';

export const useTenant = () => {
  const context = useContext(TenantContext);

  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }

  return context;
};
